module.exports = __webpack_public_path__ + "img/plus.33d3fcf5.svg";